import React from "react";
import Accordion from "react-bootstrap/Accordion";
import { formatDateTime } from "../../common-data/Converts";
import IndLeadInfo from "./IndLeadInfo";

const AllFollowupInfo = ({ rowData }) => {
  return (
    <div className="all-followuo-info-container">
      <Accordion
      // defaultActiveKey="0"
      >
        <Accordion.Item eventKey="0">
          <Accordion.Body>
            <IndLeadInfo rowData={rowData} />
          </Accordion.Body>
          <Accordion.Header>
            <div className="heade-info">
              <span className="title">Next Followup</span>
              <span className="value">
                {rowData?.next_followup_date
                  ? formatDateTime(rowData.next_followup_date)
                  : "-"}
              </span>
            </div>
          </Accordion.Header>
        </Accordion.Item>
      </Accordion>
    </div>
  );
};

export default AllFollowupInfo;
